/**
 * EWBCI 接続管理機能
 */

import { fetchAuthSession } from 'aws-amplify/auth';
import { v4 as uuidv4 } from 'uuid';

import { EWBCIError, EWBCIErrorType } from '../utils/errors';


/**
 * 接続結果
 */
export interface ConnectionResult {
    /** サブスクリプションを解除する関数 */
    unsubscribe: () => void;
    /** セッションID */
    sessionId: string;
}

/**
 * 新しいセッションIDを生成する
 */
export function generateSessionId(): string {
    return uuidv4();
}

/**
 * 現在のユーザーIDを取得する
 */
export async function getCurrentUserId(): Promise<string> {
    try {
        const session = await fetchAuthSession();
        const userId = session.userSub ?? "";

        if (!userId) {
            throw new EWBCIError(
                "User ID not found in session",
                EWBCIErrorType.Unauthorized
            );
        }

        return userId;
    } catch (error) {
        throw EWBCIError.fromError(error, EWBCIErrorType.Unauthorized);
    }
}
